import { createContext } from 'react';

import { type Person } from '@clubspark-node/clubspark-tennis-types';

import { type CloudResult, type RepositoryCacheType } from 'repository/repository';
import type PersonService from 'services/person/personService';
import PersonServiceImpl from 'services/person/personServiceImpl';
import { type EventEligibility } from 'typedefs/event';

export interface PersonContextProps {
  getPersonEventEligibility?(
    personCsIds: string[],
    tournamentId: string,
    eventId: string,
  ): Promise<CloudResult<EventEligibility>>;
  getPlayerProfile?(personId: string, tournamentId?: string, cache?: RepositoryCacheType): Promise<CloudResult<Person>>;
}

export const PersonContext = createContext<PersonContextProps>(null);
export const PersonServiceContext = createContext<PersonService>(new PersonServiceImpl());
